<script setup lang="ts">
import { PictureFields } from '~/components/cms/Media/Picture.vue'
import { VideoFields } from '~/components/cms/Media/Video.vue'
import { IconFields } from '~/components/cms/Media/Icon.vue'
import { WidthVariants } from '~/types/Content'

type SupportingData = {
  home: { width?: { value: WidthVariants } }
}

export type MediaProps = (PictureFields | VideoFields | IconFields) & { supportingData?: SupportingData }

const props = defineProps<MediaProps>()
const attrs = useAttrs()
const widthClass = props?.supportingData?.home?.width?.value === 'wide' ? 'media-panel--wide' : 'media-panel--narrow'

/* Map field structure to Media component */
const fields = {
  fields: { ...attrs, ...props },
  sys: { contentType: { sys: { id: attrs.componentName } } },
}
</script>

<template>
  <section class="media-panel" data-testid="media-panel" :class="widthClass">
    <!-- @vue-skip -->
    <Media v-bind="fields" />
  </section>
</template>

<style lang="postcss">
.media-panel {
  margin-bottom: var(--component-space);

  &.media-panel--narrow {
    max-width: 78rem; /* 1280px - 1rem inline-padding */
    margin-inline: auto;
  }
}
</style>
